
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/chargebee",
      function () {
        return require("private-next-pages/destinations/chargebee.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/chargebee"])
      });
    }
  